import React from "react";
import Layout from "../Layout";
import { Grid } from "@mui/material";
import OperatorsTableList from "../../../widgets/management/operators/OperatorsTableList";
// import OperatorsTable from "../../../widgets/management/operators/OperatorsTableManager";

function Operators(props) {
  return (
    <Layout>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <OperatorsTableList />
      </Grid>
    </Layout>
  );
}

export default Operators;
